<section>
  <header>
    <h2>{{title || 'Dashlet'}}</h2>
  </header>

  <ng-content select="[filter]"></ng-content>

  @if (loading) {
    <mat-card class="loading">
      <mat-card-content>
        <mat-icon>autorenew</mat-icon>
        Loading&hellip;
      </mat-card-content>
    </mat-card>
  }

  @if (noResults && title !== 'New Users') {
    <mat-card class="no-results">
      <mat-card-content>
        <mat-icon>sentiment_dissatisfied</mat-icon>
        None found.
      </mat-card-content>
    </mat-card>
  }

  @if (!loading) {
    <ng-content select="[data]"></ng-content>
  }
</section>
